import React from 'react';
import Client from './components/Client';
import {
  Box,
  Button,
  Divider,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import PrivacyTipOutlinedIcon from '@mui/icons-material/PrivacyTipOutlined';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import SupportAgentOutlinedIcon from '@mui/icons-material/SupportAgentOutlined';
import {
  fetchMobileImage,
  fetchMobileText,
  getMobileImageUrl,
  getMobileTextValue,
} from './components/MobileStandalone';
import OptimizedConfigImage from './components/OptimizedConfigImage';
import { withAppBasePath } from './app/runtimeConfig';

class Main extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      client: new Client("none"),
      brandName: "",
      heroImageUrl: "",
      homeTitle: "",
      homeSubtitle: "",
      optionsTitle: "",
      optionsSubtitle: "",
      supportTitle: "",
      supportText: "",
    };

    this.getData = this.getData.bind(this);
  }

  componentDidMount() {
    this.getData();
  }

  getData() {
    const client = this.state.client;
    const homeImage = fetchMobileImage(client, "HOME_IMAGE");
    const banner = fetchMobileImage(client, "BANNER");
    const brandName = fetchMobileText(client, "BRAND_NAME");
    const homeTitle = fetchMobileText(client, "HOME_TITLE");
    const homeSubtitle = fetchMobileText(client, "HOME_SUBTITLE");
    const optionsTitle = fetchMobileText(client, "ACCOUNT_OPTIONS_TITLE");
    const optionsSubtitle = fetchMobileText(client, "ACCOUNT_OPTIONS_SUBTITLE");
    const supportTitle = fetchMobileText(client, "SUPPORT_TITLE");
    const supportText = fetchMobileText(client, "SUPPORT_TEXT");

    this.setState({
      heroImageUrl: getMobileImageUrl(homeImage, "HOME_IMAGE") || getMobileImageUrl(banner, "BANNER"),
      brandName: getMobileTextValue(brandName),
      homeTitle: getMobileTextValue(homeTitle),
      homeSubtitle: getMobileTextValue(homeSubtitle),
      optionsTitle: getMobileTextValue(optionsTitle),
      optionsSubtitle: getMobileTextValue(optionsSubtitle),
      supportTitle: getMobileTextValue(supportTitle),
      supportText: getMobileTextValue(supportText),
    });
  }

  renderAction(icon, title, description, href) {
    return (
      <Button
        fullWidth
        href={href}
        sx={{
          minHeight: 74,
          justifyContent: "space-between",
          textAlign: "left",
          px: { xs: 1.5, sm: 2 },
          py: 1.35,
          borderRadius: "8px",
          color: "#171717",
          textTransform: "none",
          border: "1px solid rgba(23,23,23,0.08)",
          background:
            "linear-gradient(135deg, rgba(255,255,255,0.96) 0%, rgba(255,248,225,0.82) 100%)",
          boxShadow: "0 10px 28px rgba(116,74,22,0.08)",
          transition: "transform 160ms ease, box-shadow 160ms ease, border-color 160ms ease",
          "&:hover": {
            background:
              "linear-gradient(135deg, rgba(255,255,255,1) 0%, rgba(255,248,225,0.92) 100%)",
            borderColor: "rgba(196,81,22,0.26)",
            transform: "translateY(-1px)",
            boxShadow: "0 14px 34px rgba(116,74,22,0.12)",
          },
        }}
      >
        <Stack direction="row" spacing={1.4} alignItems="center" sx={{ minWidth: 0 }}>
          <Box
            sx={{
              width: 42,
              height: 42,
              borderRadius: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
              color: "#111111",
              background: "#F7B500",
              border: "1px solid rgba(17,17,17,0.08)",
            }}
          >
            {icon}
          </Box>

          <Box sx={{ minWidth: 0 }}>
            <Typography sx={{ fontWeight: 900, color: "#171717", lineHeight: 1.25 }}>
              {title}
            </Typography>

            <Typography variant="body2" sx={{ color: "rgba(23,23,23,0.62)", lineHeight: 1.35 }}>
              {description}
            </Typography>
          </Box>
        </Stack>

        <ChevronRightRoundedIcon sx={{ color: "#9a4f12", flexShrink: 0, ml: 1 }} />
      </Button>
    );
  }

  render() {
    const brandName = this.state.brandName || "Restaurant";
    const title = this.state.homeTitle || brandName;
    const subtitle =
      this.state.homeSubtitle || "Informații utile, accesibile rapid și ușor de citit.";
    const optionsTitle = this.state.optionsTitle || "Informații";
    const optionsSubtitle = this.state.optionsSubtitle || "Alege secțiunea de care ai nevoie.";
    const showSupport = Boolean(this.state.supportTitle || this.state.supportText);

    return (
      <Box
        sx={{
          width: "100%",
          maxWidth: "100vw",
          boxSizing: "border-box",
          px: { xs: 0.25, sm: 1 },
          py: { xs: 1, sm: 3 },
          overflowX: "hidden",
          color: "#171717",
        }}
      >
        <Box sx={{ width: "100%", maxWidth: 720, mx: "auto" }}>
          <Stack spacing={{ xs: 1.25, sm: 1.75 }} alignItems="center">
            <Box
              sx={{
                width: "100%",
                minHeight: { xs: 230, sm: 280 },
                borderRadius: "8px",
                overflow: "hidden",
                border: "1px solid rgba(116,74,22,0.10)",
                boxShadow: "0 20px 54px rgba(116,74,22,0.14)",
                bgcolor: "#17110c",
                position: "relative",
                background:
                  "linear-gradient(135deg, #431407 0%, #9a3412 48%, #0f766e 100%)",
              }}
            >
              {this.state.heroImageUrl ? (
                <OptimizedConfigImage
                  src={this.state.heroImageUrl}
                  alt=""
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    display: "block",
                  }}
                />
              ) : null}

              <Box
                sx={{
                  position: "absolute",
                  inset: 0,
                  background:
                    "linear-gradient(180deg, rgba(17,17,17,0.08) 0%, rgba(17,17,17,0.66) 100%)",
                  pointerEvents: "none",
                }}
              />

              <Stack
                spacing={1}
                sx={{
                  position: "absolute",
                  inset: 0,
                  display: "flex",
                  justifyContent: "flex-end",
                  p: { xs: 2, sm: 3 },
                  zIndex: 2,
                }}
              >
                <Box
                  sx={{
                    alignSelf: "flex-start",
                    px: 1.1,
                    py: 0.45,
                    borderRadius: "8px",
                    bgcolor: "rgba(255,255,255,0.92)",
                    color: "#9a3412",
                    fontSize: 12,
                    lineHeight: 1,
                    fontWeight: 900,
                    letterSpacing: 0,
                  }}
                >
                  Cont
                </Box>

                <Typography
                  component="h1"
                  sx={{
                    maxWidth: 620,
                    fontWeight: 950,
                    color: "#fff",
                    letterSpacing: 0,
                    fontSize: { xs: 31, sm: 42 },
                    lineHeight: 1.03,
                    textShadow: "0 12px 34px rgba(0,0,0,0.34)",
                  }}
                >
                  {title}
                </Typography>

                <Typography
                  sx={{
                    maxWidth: 540,
                    color: "rgba(255,255,255,0.86)",
                    fontSize: { xs: 14.5, sm: 16.5 },
                    fontWeight: 680,
                    lineHeight: 1.5,
                    textShadow: "0 8px 28px rgba(0,0,0,0.34)",
                  }}
                >
                  {subtitle}
                </Typography>
              </Stack>
            </Box>

            <Paper
              elevation={0}
              sx={{
                width: "100%",
                borderRadius: "8px",
                backgroundColor: "rgba(255,255,255,0.94)",
                border: "1px solid rgba(116,74,22,0.10)",
                boxShadow: "0 18px 48px rgba(116,74,22,0.10)",
                p: { xs: 1.5, sm: 2 },
              }}
            >
              <Box sx={{ px: 0.5, pb: 1.5 }}>
                <Typography sx={{ fontWeight: 950, color: "#171717", mb: 0.35 }}>
                  {optionsTitle}
                </Typography>

                <Typography variant="body2" sx={{ color: "rgba(23,23,23,0.62)" }}>
                  {optionsSubtitle}
                </Typography>
              </Box>

              <Stack spacing={1}>
                {this.renderAction(
                  <DescriptionOutlinedIcon />,
                  "Termeni",
                  "Citește termenii serviciului și condițiile de utilizare.",
                  withAppBasePath("/terms")
                )}

                {this.renderAction(
                  <PrivacyTipOutlinedIcon />,
                  "Confidențialitate",
                  "Vezi cum sunt gestionate și protejate datele personale.",
                  withAppBasePath("/privacy")
                )}
              </Stack>

              {showSupport ? (
                <>
                  <Divider sx={{ my: 2, borderColor: "rgba(23,23,23,0.08)" }} />

                  <Stack direction="row" spacing={1.25} alignItems="center">
                    <Box
                      sx={{
                        width: 38,
                        height: 38,
                        borderRadius: "8px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#9a4f12",
                        backgroundColor: "#fff2d6",
                        flexShrink: 0,
                      }}
                    >
                      <SupportAgentOutlinedIcon fontSize="small" />
                    </Box>

                    <Box>
                      {this.state.supportTitle ? (
                        <Typography sx={{ fontWeight: 900, color: "#171717", lineHeight: 1.3 }}>
                          {this.state.supportTitle}
                        </Typography>
                      ) : null}

                      {this.state.supportText ? (
                        <Typography variant="body2" sx={{ color: "rgba(23,23,23,0.62)", lineHeight: 1.45 }}>
                          {this.state.supportText}
                        </Typography>
                      ) : null}
                    </Box>
                  </Stack>
                </>
              ) : null}
            </Paper>
          </Stack>
        </Box>
      </Box>
    );
  }
}

export default Main;
